exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".option-right {\n  padding-right: 16px;\n  margin-top: 36px;\n  margin-bottom: 11px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/replication/total-replication/total-replication.component.css
// module id = 826
// module chunks = 0